import React from "react";
import { FormGroup } from "reactstrap";

const propTypes = {};

const InvoiceFields = () => {
  return (
    <div className="invoice-checkout">
      <FormGroup className="invoice-block form-fields">
        <p className="invoice-notice font-italic text-secondary">
          Notice: By selecting the 'Pay via Invoice' option, you agree to be invoiced later and to
          fulfill all payment obligations for invoiced campaigns, consistent with the terms of your
          existing agreement with Adwerx.
        </p>
      </FormGroup>
    </div>
  );
};

InvoiceFields.propTypes = propTypes;

export default InvoiceFields;
